import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { ThemedComponent } from 'ui/theme';
import { MaterialSelect } from './styled';

export const Select = ({
  placeholder,
  options,
  small,
  value,
  onChange,
  id,
  secondary,
  required,
  disabled,
}) => {
  const [opened, setOpened] = useState(false);
  const toggleOpen = () => setOpened(!opened);
  const optionAction = (item) => {
    if (onChange && typeof onChange === 'function') {
      onChange(item.target.value);
    }
    toggleOpen();
  };

  return (
    <>
      <ThemedComponent>
        <FormControl variant="standard" fullWidth>
          <InputLabel
            style={{ fontSize: '20px', marginTop: '-4px' }}
            id={id}
            shrink
            color={secondary ? 'secondary' : 'primary'}
            required={required}
          >
            {placeholder}
          </InputLabel>
          <MaterialSelect
            small={small}
            labelId={id}
            color={secondary ? 'secondary' : 'info'}
            id={id}
            value={value}
            onChange={optionAction}
            disableUnderline
            label={placeholder}
            required={required}
            disabled={disabled}
          >
            {options?.map((item, key) => (
              <MenuItem key={key} value={`${item.id}`}>
                {item?.title}
              </MenuItem>
            ))}
          </MaterialSelect>
        </FormControl>
      </ThemedComponent>
    </>
  );
};

Select.propTypes = {
  placeholder: PropTypes.string,
  options: PropTypes.array,
  value: PropTypes.object,
  small: PropTypes.bool,
  secondary: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

Select.defaultProps = {
  placeholder: '',
  options: [],
  value: undefined,
  disabled: false,
  small: false,
  secondary: false,
  onChange: undefined,
};

export default Select;
